import { generateUtilityClasses } from '@mui/material';

export const buttonGroupClasses = generateUtilityClasses('ButtonGroup', [
  'root',
  'detail',
  'dropdown',
  'dropdownMenu',
]);
